/**
 * Custom language switcher with theme editor detection
 * This helps prevent redirect loops in the theme editor
 */
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're in the theme editor
  const isInThemeEditor = window.Shopify && window.Shopify.designMode;
  
  // Get all language selector links - both in header and mobile menu
  const languageLinks = document.querySelectorAll('.custom-dropdown .dropdown-option');
  
  if (languageLinks.length && isInThemeEditor) {
    // Add click handler for the theme editor
    languageLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // Prevent default action in theme editor
        if (isInThemeEditor) {
          e.preventDefault();
          
          // Show visual feedback instead of redirecting
          const selectedText = this.closest('.custom-select-wrapper')
            .querySelector('.selected-text');
          
          // Store original text
          const originalText = selectedText.textContent;
          
          // Get the language code from the link text
          const langCode = this.querySelector('span').textContent;
          
          // Update the flag
          const flagContainer = this.closest('.custom-select-wrapper')
            .querySelector('.select-flag');
          const newFlagSrc = this.querySelector('img').src;
          
          // Update the flag image
          if (flagContainer && flagContainer.querySelector('img')) {
            flagContainer.querySelector('img').src = newFlagSrc;
          }
          
          // Update the text
          if (selectedText) {
            selectedText.textContent = langCode;
            
            // Visual feedback
            selectedText.style.transition = 'opacity 0.3s';
            selectedText.style.opacity = '0.5';
            setTimeout(() => {
              selectedText.style.opacity = '1';
            }, 500);
          }
          
          // Close the dropdown
          document.addEventListener('click', function closeDropdown() {
            const dropdown = document.querySelector('.custom-dropdown');
            if (dropdown) dropdown.classList.remove('active');
            document.removeEventListener('click', closeDropdown);
          }, { once: true });
          
          console.log('Language switcher: prevented redirect in theme editor');
        }
      });
    });
  }
});
